export const YES = 'Yes';
export const NO = 'No';
export const EN_US = 'en-US';
export const EN_GB = 'en-GB';
export const BRAND_ADJUSTMENTS = 'BRAND_ADJUSTMENTS';
export const CUP_COMPENSATION = 'CUP_COMPENSATION';
export const UPDATE_BACK = 'UPDATE_BACK';
export const UPDATE_CUP = 'UPDATE_CUP';
